export default {
  mobile_app_average_order_value: {
    label: 'VME via App',
  },
  mobile_app_gmv: {
    label: 'Vendas da App',
  },
  mobile_app_gmv_percentage: {
    label: '% Receita via App',
  },
  mobile_app_downloads: {
    label: 'Downloads',
  },
  mobile_app_orders_count: {
    label: 'Encomendas da App',
  },
  name: {
    label: 'Restaurante',
  },
  mobile_app_released_at: {
    label: 'Data de lançamento',
  },
  title: 'Diretório de Restaurantes',
};
